/**
 * Collection ajax loader for zh-tabs-product-list.
 * Fetches next pages from collection.zh-tabs and appends product items.
 */
(function (global) {
  var AJAX_VIEW = "zh-tabs";

  function productIdOf(el) {
    if (!el) return "";
    var id = el.getAttribute("data-product-id");
    if (id) return id;
    var match = (el.className || "").match(/t4s-pr-(\d+)/);
    return match ? match[1] : "";
  }

  async function loadNext(panel, ctx) {
    ctx = ctx || {};
    var collectionUrl = panel.dataset.collectionUrl;
    var nextPage = Number(panel.dataset.nextPage || "2");
    var lastPage = Number(panel.dataset.lastPage || "1");
    var grid = panel.querySelector("[data-zh-tabs-grid]");

    if (!collectionUrl || !grid || nextPage > lastPage) {
      panel.dataset.hasMore = "false";
      return;
    }

    var url = new URL(collectionUrl, window.location.origin);
    url.searchParams.set("view", AJAX_VIEW);
    url.searchParams.set("page", String(nextPage));

    var response = await fetch(url.toString(), {
      signal: ctx.signal,
      credentials: "same-origin",
      headers: { Accept: "text/html" }
    });

    if (!response.ok) throw new Error("Failed to load products (" + response.status + ")");

    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, "text/html");
    var root = doc.querySelector("[data-zh-tabs-ajax-root]");
    var items = root
      ? root.querySelectorAll(".t4s-product.t4s-col-item")
      : doc.querySelectorAll(".t4s-product.t4s-col-item");
    var resolvedLastPage = Number((root && root.getAttribute("data-last-page")) || lastPage);

    if (items.length) {
      var existingIds = {};
      var existing = grid.querySelectorAll(".t4s-product.t4s-col-item");
      for (var i = 0; i < existing.length; i++) {
        var id = productIdOf(existing[i]);
        if (id) existingIds[id] = true;
      }

      var fragment = document.createDocumentFragment();
      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        var productId = productIdOf(item);
        if (productId && existingIds[productId]) continue;
        if (productId) existingIds[productId] = true;
        fragment.appendChild(item);
      }
      grid.appendChild(fragment);
    }

    var loadedPage = Number((root && root.getAttribute("data-page")) || nextPage);
    var hasMore = loadedPage < resolvedLastPage && items.length > 0;

    panel.dataset.nextPage = String(loadedPage + 1);
    panel.dataset.lastPage = String(resolvedLastPage);
    panel.dataset.hasMore = hasMore ? "true" : "false";
  }

  global.ZhTabsCollection = {
    loadNext: loadNext
  };
})(typeof window !== "undefined" ? window : this);
